/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignMetaAnalyticsDataSchema = z.object({
	metaCampaignConcluded: z.boolean(),
	reach: z.number().nullable(),
	impressions: z.number().nullable(),
	clicks: z.number().nullable(),
	clickThroughRate: z.number().nullable(),
	outboundClicks: z.number().nullable(),
	outboundClicksCtr: z.number().nullable(),
})

export type CampaignMetaAnalyticsDataSchema = z.infer<typeof campaignMetaAnalyticsDataSchema>
